import React from 'react';
import './CashpointsBalance.less';

export const CashpointsBalance = ({text}) => {
	return <span className="cashpoints-balance">{text}</span>
}
